import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import AdsterraBanner468x60 from "../common/AdsterraBanner468x60";
import AdsterraNativeBanner from "../common/AdsterraNativeBanner";

const MainLayout = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <AdsterraNativeBanner />
      <AdsterraBanner468x60 />
      <Footer />
    </div>
  );
};

export default MainLayout;
